export enum AccountTypes {
    Users = 1,
    PrinterDevices = 2,
    SelectableCostAccounts = 3,
}
